__webpack_require__.p = "https://ajna.himalayanjava.com/";